import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_modal, {
      "have-modal": _ctx.haveModal,
      "is-displayed": _ctx.isChangeApplicationOpened,
      "is-select-modal": true,
      "no-padding": true,
      title: "Change device group",
      onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-modal')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_form_wrapper, {
          "is-form-in-modal": _ctx.isFormInModal,
          "is-loading": _ctx.isLoading,
          "need-for-scroll": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createVNode(_component_form_divider, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Group", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedApplicationId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedApplicationId) = $event)),
                      class: _normalizeClass(`mt-1`),
                      options: _ctx.applications,
                      reduce: (spot) => spot.id,
                      label: "name"
                    }, null, 8, ["modelValue", "options", "reduce"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
            ], 32)
          ]),
          _: 1
        }, 8, ["is-form-in-modal", "is-loading"])
      ]),
      _: 1
    }, 8, ["have-modal", "is-displayed"])
  ]))
}